import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FormatPrice } from 'utils/format';

const t = {
  vat_not_included: '+ VAT',
};

const CostTotal = ({ total, currency }) => {
  return (
    <Fragment>
      <FormatPrice currency={currency} value={total} /> {t.vat_not_included}
    </Fragment>
  );
};

CostTotal.propTypes = {
  currency: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};

export default CostTotal;
